const pageSize = 50;

const module = 'Alert';

const assetDetailsTab = 'ASSET_DETAILS';

const personalizationCategory = 'AlertView';

const defaultOptions = {
  page: 1,
  sort: [
    {
      attribute: 'createdTime',
      order: 'ASC'
    }
  ],
  condition: null
};

const PatchSeverityColorMap = {
  Critical: 'critical',
  Important: 'warning',
  Medium: 'attention',
  Low: 'info',
  Optional: 'info',
  Others: '',
  Recommended: 'success'
};

const alertEntities = ['Alert', 'Asset', 'Client', 'Site', 'Policy'];

export {
  pageSize,
  defaultOptions,
  module,
  assetDetailsTab,
  personalizationCategory,
  PatchSeverityColorMap,
  alertEntities
};
